module.exports = function() {
  return new Worker(__webpack_public_path__ + "3c0c737166dd4ae3fae3.worker.js");
};